import { UseMutateAsyncFunction } from '@tanstack/react-query';
import { graphql } from '../../gql';
import { useApiMutation } from '../../query/hooks';
import { useIntl } from 'react-intl';
import { type TypedDocumentNode } from '@graphql-typed-document-node/core';
import { mutationResponseHandler } from '../../utils/mutationResponseHandler';
import { useSnackbar } from '../../store/snackbar';

const journeyUpdateMutation = graphql(`
	mutation journeyUpdateTeamMutation($journeyId: UUID!, $journeyName: String!, $teams: [JourneyUpdateTeamsEntityRelationInput!]) {
		updateJourney(by: { id: $journeyId }, data: { name: $journeyName, teams: $teams }) {
			ok
			errorMessage
		}
	}
`);

type MutateFunction<Node> = Node extends TypedDocumentNode<infer R, infer V> ? UseMutateAsyncFunction<R, unknown, V> : never;

type CreateJourneyRaciMutationResult = {
	journeyUpdate: MutateFunction<typeof journeyUpdateMutation>;
};

const useUpdateJourney = (): CreateJourneyRaciMutationResult => {
	const intl = useIntl();
	const { openSnackbar } = useSnackbar();
	const { mutateAsync: journeyUpdate } = useApiMutation(journeyUpdateMutation, {
		onSuccess: (result) => {
			mutationResponseHandler({
				result: result.updateJourney.ok,
				toastMessages: {
					success: intl.formatMessage({ id: 'form.journey.update.success.submit' }),
					error: intl.formatMessage({ id: 'form.journey.update.error.submit' }),
				},
				errorMessage: result.updateJourney.errorMessage,
				openSnackbar,
			});
		},
	});

	return { journeyUpdate };
};

export { useUpdateJourney };
